<template>
    <svg height="18" viewBox="0 0 16.984 17.258" width="18" xmlns="http://www.w3.org/2000/svg">
        <path
            id="Icon_awesome-power-off"
            d="M13.985,1.852a8.491,8.491,0,1,1-9.868,0,.824.824,0,0,1,1.2.264l.541.962A.821.821,0,0,1,5.63,4.143a5.752,5.752,0,1,0,6.845,0,.817.817,0,0,1-.223-1.058l.541-.962a.821.821,0,0,1,1.192-.267ZM10.424,9.04V.822A.82.82,0,0,0,9.6,0h-1.1a.82.82,0,0,0-.822.822V9.04a.82.82,0,0,0,.822.822H9.6A.82.82,0,0,0,10.424,9.04Z"
            data-name="Icon awesome-power-off"
            fill="#f64e60"
            transform="translate(-0.563)"
        />
    </svg>
</template>

<script>
export default {
    name: "Offline",
};
</script>
